import React from 'react';
import {
  TextField,
} from '@material-ui/core';
import {TextFieldProps} from '@material-ui/core/TextField';
import {makeStyles, Theme} from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#264259',
      },
    },
  },
  input: {
    color: theme.palette.primary.main,
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
}));

export default function TextEmail(props: TextFieldProps): JSX.Element {
  const classes = useStyles();
  const { required, inputProps, InputLabelProps, ...rest } = props;

  return (
    <TextField
      InputProps={{
        className: classes.input,
      }}
      type="email"
      variant="outlined"
      className={classes.textField}
      fullWidth
      {...rest}
      InputLabelProps={{ ...InputLabelProps, required: Boolean(required) }}
      inputProps={{ ...inputProps, required: undefined }}
    />
  );
}